export const PERSON_TYPE_LABELS = {
    FILER: 'multiTaxHousehold.primaryTaxFiler',
    DEPENDENT: 'multiTaxHousehold.taxDependent',
    FILER_DEPENDENT: 'multiTaxHousehold.taxDependent',
    UNSPECIFIED: 'multiTaxHousehold.nonFiler',
    NA: 'common.na',
};
